import city from '@/plugins/i18n/city.json';
import store from '@/plugins/i18n/store.json';

import lotto from '@/plugins/i18n/lotto.json';
import rank from '@/plugins/i18n/rank.json';
import main from '@/plugins/i18n/main.json';
import etc from '@/plugins/i18n/etc.json';
import guide from '@/plugins/i18n/guide.json';
import map from '@/plugins/i18n/map.json';
import modal from '@/plugins/i18n/modal.json';
import community from '@/plugins/i18n/community.json';
import subscription from '@/plugins/i18n/subscription.json';
import mypage from '@/plugins/i18n/mypage.json';
import property from '@/plugins/i18n/property.json';
import unsubscribe from '@/plugins/i18n/unsubscribe.json';
import noti from '@/plugins/i18n/noti.json';
import setting from '@/plugins/i18n/setting.json';
import notfound from '@/plugins/i18n/notfound.json';
import whiteday from '@/plugins/i18n/whiteday.json';

import event from '@/plugins/i18n/event.json';

import nycopenevent from '@/plugins/i18n/nycopenevent.json';
import wp from '@/plugins/i18n/wp.json';
import megalotto from '@/plugins/i18n/megalotto.json';

export {
  city,
  store,
  lotto,
  rank,
  main,
  etc,
  guide,
  map,
  modal,
  community,
  subscription,
  mypage,
  property,
  unsubscribe,
  noti,
  setting,
  notfound,
  event,
  nycopenevent,
  whiteday,
  wp,
  megalotto,
};
